// Keep thresholds in sync with server/services/doctorDashboardService.js (isAbnormalVitals)

export const getAbnormalVitalParts = (visit) => {
  const parts = [];

  const systolic = parseFloat(visit?.blood_pressure_systolic);
  const temp = parseFloat(visit?.temperature);
  const spo2 = parseFloat(visit?.spo2);

  if (systolic && (systolic > 140 || systolic < 90)) {
    parts.push({ label: 'BP', value: String(systolic) });
  }
  if (temp && (temp > 38 || temp < 36)) {
    parts.push({ label: 'Temp', value: String(temp) });
  }
  if (spo2 && spo2 < 95) {
    parts.push({ label: 'SpO2', value: `${spo2}%` });
  }

  return parts;
};

export const isAbnormalVitals = (visit) => getAbnormalVitalParts(visit).length > 0;

export const formatAbnormalVitalsLabel = (visit) => {
  const parts = getAbnormalVitalParts(visit);
  if (parts.length === 0) return null;

  const detail = parts.map(({ label, value }) => `${label}:${value}`).join(', ');
  return `Abnormal Vitals. ${detail}`;
};
